import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions, buildDropdownAudit} from '../../../reusable'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import {Tr} from '../../../_metronic/i18n/Tr'

const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

function Popup(props: any) {
    let t = Tr()

    const [name, setName] = useState(props.name || '') // Local state for name
    const [error, setError] = useState({}) as any
    const [disable, setDisable] = useState(false)
    const [selectedMxikkodiId, setSelectedMxikkodiId] = useState(props.mxikkodiId || '')
    const [oldMxikkodi, setOldMxikkodi] = useState<any>(null)
    const [mxikkodiList, setmxikkodiList] = useState([])

    const mxikkodListApiCall = async () => {
      var response = await fetchData('admin/viewmxikkodi', {})
      if (response.status == '200') {
        var data = response.data
        var opt: any = []
        data.map((val: any) => {
          opt.push({value: val.mxikkodiId, label: val.name})
        })

        setmxikkodiList(opt)
        if (props.mxikkodiId) {
          const oldOpt = opt.find((o: any) => o.value == props.mxikkodiId)
          setOldMxikkodi(oldOpt || null)
        }
      } else {
        toasterrormsg(response.message)
      }
    }

    useEffect(() => {
      mxikkodListApiCall()
    }, [])

    const saveOIchovBirligi = async () => {
      setDisable(true)
      let param = {
        name: name,
        mxikkodiId: selectedMxikkodiId,
        oIchovBirligiId: props.oIchovBirligiId,
        adminId: adminId,
        labels: buildDropdownAudit({
          mxikkodiId: { old: oldMxikkodi, new: mxikkodiList.find((o: any) => o.value == selectedMxikkodiId) || null },
        }),
      }
      var res = await fetchData('admin/saveoIchovBirligi', param)
      if (res.status == '200') {
        toastsuccessmsg(
          props.oIchovBirligiId
            ? `O'Ichov Birligi Updated Successfully`
            : `O'Ichov Birligi Added Successfully`
        )
        setDisable(false)
        props.onHide()
        props.onSave() // Trigger refresh in parent
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }

    const validate = () => {
      let errotmp: any = {}
      let err = 0
      if (!name.trim()) {
        errotmp['nameError'] = t(`O'Ichov Birligi Name Is Required`)
        err = 1
      } else if (name.trim().length > 50) {
        errotmp['nameError'] = t(`O'Ichov Birligi Is Too Large`)
        err = 1
      }
      if (
        selectedMxikkodiId == '' ||
        selectedMxikkodiId == undefined ||
        selectedMxikkodiId == null
      ) {
        errotmp['mxikkodiError'] = t('Mxikkodi Is Required')
        err = 1
      }
      setError(errotmp)
      if (err === 0) saveOIchovBirligi()
    }

    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>
              {props.oIchovBirligiId ? t('Edit') : t('Add')} {t("O'Ichov Birligi")}
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className='stepper stepper-links d-flex flex-column' id='kt_create_account_stepper'>
            <div className='mx-auto mw-600px w-100 py-10' id='kt_create_account_form'>
              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t(`O'Ichov Birligi Name`)}
                </label>
                <input
                  type='text'
                  name='mxikkodiName'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t(`O'Ichov Birligi Name`)}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <label className='text-danger'>{error.nameError || ''}</label>
              </div>
              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t('Select Mxikkodi')}
                </label>
                <Select
                  options={mxikkodiList}
                  value={
                    mxikkodiList.find((option: any) => option.value === selectedMxikkodiId) || ''
                  }
                  placeholder={t('Select Mxikkodi')}
                  isMulti={false}
                  onChange={(e: any) => {
                    setSelectedMxikkodiId(e.value)
                  }}
                />
                <label className='text-danger'>{error.mxikkodiError}</label>
              </div>
              <div className='d-flex pt-15 justify-content-center'>
                <button
                  type='button'
                  className='btn btn-lg btn-light-success me-3'
                  onClick={props.onHide}
                >
                  {t('Cancel')}
                </button>
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-lg btn-success monthBtn me-3'
                  onClick={validate}
                >
                  {!disable ? (
                    t('Save')
                  ) : (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

// Move Popup component outside of viewoIchovBirligiId
function ViewOIchovBirligi() {
  let t = Tr()
  const {menuIdAdd, menuIdEdit, menuIdDelete} = useMenuIdPermissions()

  const [showPopup, setShowPopup] = useState(false)
  const [oIchovBirligiList, setOIchovBirligiList] = useState([])
  const [orgOIchovBirligiList, setOrgOIchovBirligiList] = useState([])
  const [name, setName] = useState('')
  const [mxikkodiId, setMxikkodiId] = useState('')
  const [oIchovBirligiId, setOIchovBirligId] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)

  const oIchovBirligiListApiCall = async () => {
    var response = await fetchData('admin/viewoIchovBirligi', {})
    if (response.status == '200') {
      setOIchovBirligiList(response.data)
      setOrgOIchovBirligiList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = `Insayr | O'Ichov Birligi`
    oIchovBirligiListApiCall()
  }, [])

  const column: any = useMemo(
    () => [
      {
        name: t(`O'Ichov Birligi Name`),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.name}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.name),
      },
      {
        name: t('Mxikkodi Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.mxikkodiname}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.mxikkodiname),
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
         {menuIdEdit ?   <button
              className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
              title='Edit'
              onClick={() => {
                setShowPopup(true)
                setOIchovBirligId(row.oIchovBirligiId)
                setMxikkodiId(row.mxikkodiId)
                setName(row.name)
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button> :""}
          {menuIdDelete ?  <button
              className='btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2'
              title='delete'
              onClick={() => deleteoIchovBirligi(row.oIchovBirligiId)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button> :""}
          </>
        ),
      },
    ],
    [t]
  )

  const deleteoIchovBirligi = async (oIchovBirligiId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t(`You Want To Delete O'Ichov Birligi!`),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'), // Custom OK button text
      cancelButtonText: t('Cancel'), // Custom Cancel button text
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetchData('admin/deleteMasterData', {
            type: 'oIchovBirligi',
            adminId: adminId,
            typeId: String(oIchovBirligiId),
          })
          if (response.status == '200') {
            toastsuccessmsg(response.message)
            oIchovBirligiListApiCall()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  const CustomHeader = (props: any) => {
    const inputRef = useRef(null) as any
    const handleChange = async (e: any) => {
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      if (inputRef.current && props.isfoc === 1) inputRef.current.focus()
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t(`Search O'Ichov Birligi`)}
            value={props.search}
            onChange={(e) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8' data-kt-user-table-toolbar='base'>
          {menuIdAdd ? (
            <button type='button' className='btn btn-success' onClick={() => setShowPopup(true)}>
              <KTIcon iconName='plus' className='fs-2' />
              {t("Add O'Ichov Birligi")}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    )
  }

  const oIchovBirligiSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)
    if (!text) {
      setOIchovBirligiList(orgOIchovBirligiList)
    } else {
      const tmp = orgOIchovBirligiList.filter((item: any) =>
        ['name', 'mxikkodiname'].some((key) =>
          item[key]?.toLowerCase()?.includes(text.toLowerCase())
        )
      )
      setOIchovBirligiList(tmp)
    }
  }


  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgOIchovBirligiList.length > 0 ? (
              <DataTable
                columns={column}
                data={oIchovBirligiList}
                pagination
                paginationServer={false}
                subHeader={true}
                subHeaderComponent={
                  <CustomHeader
                    search={searchTerm}
                    isfoc={focus}
                    customSearch={oIchovBirligiSearch}
                  />
                }
                paginationComponentOptions={{
                  rowsPerPageText: t('Rows Per Page'),
                }}
              />
            ) : (
              <div className='text-center px-4'>
                <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                  <h2 className='fs-2x fw-bold'>{t("Welcome To O'Ichov Birligi")}</h2>
                </div>
                <p className='text-gray-400 fs-4 fw-semibold'>
                  {t("There are no O'Ichov Birligi")}
                </p>
                {menuIdAdd ? (
                  <Link
                    to='#'
                    className='btn btn-success monthBtn'
                    onClick={() => setShowPopup(true)}
                  >
                    {t("Add O'Ichov Birligi")}
                  </Link>
                ) : (
                  ''
                )}
                <br />
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        {showPopup && (
          <Popup
            show={showPopup}
            onHide={() => {
              setShowPopup(false)
              setMxikkodiId('')
              setOIchovBirligId('')
              setName('')
            }}
            mxikkodiId={mxikkodiId}
            oIchovBirligiId={oIchovBirligiId}
            name={name}
            onSave={oIchovBirligiListApiCall}
          />
        )}
      </div>
    </>
  )
}

export default ViewOIchovBirligi
